const pctCls = (p) =>
  p == null ? "text-stone-400" : p >= 90 ? "text-[#1e8449]" : p >= 85 ? "text-[#8a5d14]" : "text-[#C0392B]";

export function EvvWindows({ data, testPrefix = "evv-w" }) {
  if (!data) return null;
  const tiles = [
    ["Last 30 days", data.last_30_days, `${testPrefix}-last-30`],
    ["Previous week", data.previous_week, `${testPrefix}-prev-week`],
    [`Current quarter (${data.current_quarter?.label || ""})`, data.current_quarter, `${testPrefix}-cur-q`],
    [`Previous quarter (${data.previous_quarter?.label || ""})`, data.previous_quarter, `${testPrefix}-prev-q`],
    ["Overall", data.overall, `${testPrefix}-overall`],
  ];
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5" data-testid={`${testPrefix}-grid`}>
      {tiles.map(([label, w, tid]) => (
        <div key={tid} className="rounded-md border border-stone-100 bg-stone-50 p-3" data-testid={tid}>
          <p className={`font-heading text-xl font-bold ${pctCls(w?.pct)}`}>{w?.pct != null ? `${w.pct}%` : "—"}</p>
          <p className="text-[10px] font-medium uppercase tracking-wide text-stone-500">{label}</p>
          {w?.label?.includes("→") && <p className="text-[9px] text-stone-400">{w.label}</p>}
          <p className="text-[10px] text-stone-400">
            {w?.total ? `${w.verified ?? "?"}/${w.total} verified` : w?.note || (w?.months ? `${w.months} mo on file` : "no data")}
          </p>
        </div>
      ))}
    </div>
  );
}
